import { Link, LinkProps } from 'react-router-dom';
import './styles.css';

const CustomLink = (props: LinkProps) => <Link {...props} className="staticLink" />;

export default CustomLink;
